var React = require('react');

function EditSquare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M19 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6","stroke":"currentColor","strokeWidth":"1.6","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fill":"none","d":"M16.5 3.5a2.121 2.121 0 1 1 3 3L9 17l-4 1 1-4 10.5-10.5z","stroke":"currentColor","strokeWidth":"1.6","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

EditSquare.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = EditSquare;

EditSquare.default = EditSquare;
